var _circle, _path, _circle2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAcn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 35,
    viewBox: "0 0 36 35",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 17.5747,
    r: 16,
    stroke: "#1020AE",
    strokeWidth: 2.15013
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.3667 31.1223C27.3667 25.9491 23.173 21.7554 17.9997 21.7554C12.8265 21.7554 8.63281 25.9491 8.63281 31.1223",
    stroke: "#1020AE",
    strokeWidth: 2.15013
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 18.0002,
    cy: 13.74,
    r: 5.08032,
    stroke: "#1020AE",
    strokeWidth: 2.15013
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAcn);
export default __webpack_public_path__ + "static/media/acn.be43b79d1006702175d670bbf2842926.svg";
export { ForwardRef as ReactComponent };